// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.waitlist.WaitlistWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  WaitlistWebApiHandler_addToGenericWaitlist,
  WaitlistWebApiHandler_addToWaitlist,
  WaitlistWebApiHandler_declineToWaitlist,
  WaitlistWebApiHandler_deleteByState,
  WaitlistWebApiHandler_isOnWaitlist,
  WaitlistWebApiHandler_isOnWaitlist_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  AddToGenericWaitlistWebApiRequestDto,
  AddToWaitlistWebApiRequestDto,
  DeclineToWaitlistRequestDto,
  IsOnWaitlistWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface DeleteByStateParams {
  state: string;
}
interface IsOnWaitlistParams {
  propertyId: string;
}

export interface WaitlistWebApiHandler_addToGenericWaitlist_Args {
  postData: AddToGenericWaitlistWebApiRequestDto;
}

export type WaitlistWebApiHandler_addToGenericWaitlist_Options = UseMutationOptions<
  void,
  unknown,
  WaitlistWebApiHandler_addToGenericWaitlist_Args
>;

/**
 * Add to Generic Waitlist
 */
export const useWaitlistWebApiHandler_addToGenericWaitlist = ({
  httpClient,
  ...options
}: Omit<WaitlistWebApiHandler_addToGenericWaitlist_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: WaitlistWebApiHandler_addToGenericWaitlist_Args) =>
      WaitlistWebApiHandler_addToGenericWaitlist(args.postData, httpClient),
  });
};

export interface WaitlistWebApiHandler_addToWaitlist_Args {
  postData: AddToWaitlistWebApiRequestDto;
}

export type WaitlistWebApiHandler_addToWaitlist_Options = UseMutationOptions<
  void,
  unknown,
  WaitlistWebApiHandler_addToWaitlist_Args
>;

/**
 * add listing and user Ids to waitlist
 */
export const useWaitlistWebApiHandler_addToWaitlist = ({
  httpClient,
  ...options
}: Omit<WaitlistWebApiHandler_addToWaitlist_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: WaitlistWebApiHandler_addToWaitlist_Args) =>
      WaitlistWebApiHandler_addToWaitlist(args.postData, httpClient),
  });
};

export interface WaitlistWebApiHandler_declineToWaitlist_Args {
  postData: DeclineToWaitlistRequestDto;
}

export type WaitlistWebApiHandler_declineToWaitlist_Options = UseMutationOptions<
  void,
  unknown,
  WaitlistWebApiHandler_declineToWaitlist_Args
>;

/**
 * add decline listing and user Ids to waitlist
 */
export const useWaitlistWebApiHandler_declineToWaitlist = ({
  httpClient,
  ...options
}: Omit<WaitlistWebApiHandler_declineToWaitlist_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: WaitlistWebApiHandler_declineToWaitlist_Args) =>
      WaitlistWebApiHandler_declineToWaitlist(args.postData, httpClient),
  });
};

export interface WaitlistWebApiHandler_deleteByState_Args {
  getParams: DeleteByStateParams;
}

export type WaitlistWebApiHandler_deleteByState_Options = UseMutationOptions<
  void,
  unknown,
  WaitlistWebApiHandler_deleteByState_Args
>;

/**
 * delete waitlist by state
 */
export const useWaitlistWebApiHandler_deleteByState = ({
  httpClient,
  ...options
}: Omit<WaitlistWebApiHandler_deleteByState_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: WaitlistWebApiHandler_deleteByState_Args) =>
      WaitlistWebApiHandler_deleteByState(args.getParams, httpClient),
  });
};

export type WaitlistWebApiHandler_isOnWaitlist_Options = UseQueryOptions<
  IsOnWaitlistWebApiResponseDto,
  unknown,
  IsOnWaitlistWebApiResponseDto,
  Array<string | IsOnWaitlistParams>
>;

const WaitlistWebApiHandler_isOnWaitlist_GetKey = (getParams: IsOnWaitlistParams) => [
  WaitlistWebApiHandler_isOnWaitlist_Path,
  getParams,
];

/**
 * get is listing on waitlist
 */
export const useWaitlistWebApiHandler_isOnWaitlist = (
  getParams: IsOnWaitlistParams,
  {
    httpClient,
    ...options
  }: Omit<WaitlistWebApiHandler_isOnWaitlist_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: WaitlistWebApiHandler_isOnWaitlist_GetKey(getParams),
    queryFn: () => WaitlistWebApiHandler_isOnWaitlist(getParams, httpClient),
  });
};
useWaitlistWebApiHandler_isOnWaitlist.getKey = WaitlistWebApiHandler_isOnWaitlist_GetKey;
